import BGVideo from './BGVideo';

export default BGVideo;
